//export const LOGIN_DEFAULT_URL = 'https://tconnect.tuttnauer.com/login';
export const LOGIN_DEFAULT_URL = 'https://qa.tuttnaueriot.com/login';
